<ngx-loading-bar></ngx-loading-bar>
<router-outlet>
  <app-subscription *ngIf="!viewed"></app-subscription>
</router-outlet>

<app-tap-to-top></app-tap-to-top>

<!-- <app-layout-box></app-layout-box> -->
